import type { AllRouteEndpoints } from "../routeTypes";
export const engagementCampaignsCloneCacheKeys: AllRouteEndpoints[] = ["/engagement/:app_group_id/surveys"];
